import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-aside',
	templateUrl:'./WaAsidePluginCompPage.html',
	styles: [],
	styleUrls:['./WaAsidePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaAsidePluginCompPage
{
	mdContent_1116 = `\`\`\`java
import com.jwebmp.webawesomepro.WaAside;
\`\`\``;
	mdContent_1117 = `\`\`\`java
new WaAside&lt;&gt;()
\`\`\``;
}
